import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Nav/Navbar";
import Footer from "../components/Footer/Footer";
import Button from "../components/Button/Button";
import './book.css';

const Questions_1 = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Раздел 1. Контрольные вопросы</title>
            </Helmet>
            <Navbar />
            <div className="main">
                <div className="main_item">
                    <h2 className="h2_main">Раздел 1. Организация технического обслуживания ЭВМ</h2>
                    <Button link_left="/book/lecture_1_8" link_rigth="/book/lecture_2_1" />
                    <div className="charter_book">
                        <h4 className="h3_main">Контрольные вопросы</h4>
                        <ol>
                            <li>Что включает в себя ТО СВТ?</li>
                            <li>Что представляет собой централизованное ТО СВТ?</li>
                            <li>Чем ежемесячная профилактика отличается от ежегодной?</li>
                            <li>В чем состоят различия между активной и пассивной профилактикой?</li>
                            <li>Чем опасны электростатические разряды при обслуживании СВТ?</li>
                            <li> От чего зависит периодичность проведения профилактического обслуживания?</li>
                            <li>Для чего необходима плата POST?</li>
                            <li>Чем можно извлекать и устанавливать микросхемы на материнской плате?</li>
                            <li>Для чего нужна система автоматизированного контроля?</li>
                            <li>Что является первичным контролем при загрузке ПК?</li>
                            <li>Какими способами можно автоматически восстановить операционную систему Windows?</li>
                            <li>Какие вам известны системы диагностирования?</li>
                            <li>Что включает в себя процесс диагностирования?</li>
                            <li>В чем заключается принцип «раскрутки»</li>
                            <li>Какие существуют методы диагностирования?</li>
                            <li>Почему при ТО СВТ лучше использовать комбинированный контроль?</li>
                            <li>Что представляет собой микродиагностика?</li>
                            <li>Для чего предназначены диагностические программы общего назначения?</li>
                            <li>Чем диагностические программы общего назначения отличаются от диагностических программ специального назначения?</li>
                            <div className="main_charter_point_delete">Тема 1.5. Взаимодействие и сравнительные характеристики систем автоматического контроля, диагностирования и восстановления</div>
                        </ol>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Questions_1